/**
 * Gravity forms
 */

  // custom validate profile form count m fields
  // const gform_submit = document.querySelector('#gform_19');

  // gform_submit.addEventListener('submit', function(event) {

  //   const repeater_m_counts = document.querySelectorAll('.gform_repeater_count_m input');
  //   repeater_m_counts.forEach((item) => {

  //     if (parseInt(item.value) < parseInt(item.getAttribute('min'))) {

  //       event.preventDefault();

  //       const validity = item.validity.rangeUnderflow;

  //       if (validity == true) {
  //         item.setCustomValidity("invalid");
  //       } else {
  //         item.setCustomValidity("");
  //       }

  //       item.reportValidity();
  //     }
  //   });

  // });


// profile form count pcs value
function profile_form_pcs_value (item) {

  var product_select = item.querySelector('.gfield--type-select select');
  var product_title = product_select.options[product_select.selectedIndex].innerHTML;
  var product_kgm = product_select.options[product_select.selectedIndex].getAttribute('data-profile-weight');
  var product_count_pcs = item.querySelector('.gform_repeater_count_pcs input').value;

  if (!product_kgm || product_title.includes('SET')) {
    product_count_pcs = product_count_pcs;
  } else {
    product_count_pcs = '';
  }

  return product_count_pcs;
}


// profile form count m min value
function profile_form_m_min (item) {
  var product_select = item.querySelector('.gfield--type-select select');
  var product_title = product_select.options[product_select.selectedIndex].innerHTML;
  var product_kgm = product_select.options[product_select.selectedIndex].getAttribute('data-profile-weight');
  var product_quality = item.querySelector('.gfield--type-radio input:checked').value;
  var kg_min = 0;

  if ( product_quality == 'en-aw-6063') {
    kg_min = 250;
  } else {
    kg_min = 500;
  }

  if (!product_kgm || product_title.includes('SET')) {
    var product_count_min = '';
  } else {
    var product_count_min = Math.ceil(kg_min / product_kgm);
  }

  return product_count_min;
}

// profile form count kg value
function profile_form_kg_value (item) {
  var product_select = item.querySelector('.gfield--type-select select');
  var product_title = product_select.options[product_select.selectedIndex].innerHTML;
  var product_kgm = product_select.options[product_select.selectedIndex].getAttribute('data-profile-weight');
  var product_quality = item.querySelector('.gfield--type-radio input:checked').value;
  var kg_min = 0;

  if ( product_quality == 'en-aw-6063') {
    kg_min = 250;
  } else {
    kg_min = 500;
  }

  if (!product_kgm || product_title.includes('SET')) {
    var product_count_min = '';
    var product_count_kg_value = '';
  } else {
    var product_count_min = Math.ceil(kg_min / product_kgm);
    var product_count_kg_value = Math.round(product_count_min * product_kgm);
  }

  return product_count_kg_value;
}


// profile form hide fields
function profile_form_hide_fields (item) {
  var product_select = item.querySelector('.gfield--type-select select');
  var product_kgm = product_select.options[product_select.selectedIndex].getAttribute('data-profile-weight');
  var product_title = product_select.options[product_select.selectedIndex].innerHTML;

  // if kgm empty or product title contains "set"
  if (!product_kgm || product_title.includes('SET')) {
    // add class to parent repeater item
    item.classList.add('hide-count-fields');
  }
}

// profile form default values on load
document.addEventListener("DOMContentLoaded", function(event) {
  var items = document.querySelectorAll('.gfield_repeater_item')[0];

  if (items) {
    var product_count_m_field = items.querySelector('.gform_repeater_count_m input');
    var product_count_kg_field = items.querySelector('.gform_repeater_count_kg input');
    var product_count_pcs_field = items.querySelector('.gform_repeater_count_pcs input');

    profile_form_hide_fields(items);

    if (product_count_pcs_field) {
      product_count_pcs_field.value = profile_form_pcs_value(items);
    }

    product_count_m_field.value = profile_form_m_min(items);
    product_count_m_field.setAttribute("min", profile_form_m_min(items));
    product_count_kg_field.value = profile_form_kg_value(items)
  }
});

jQuery(document).on('gform_post_render', function() {


  var items = document.querySelectorAll('.gfield_repeater_item');

  items.forEach((item) => {

    profile_form_hide_fields(item);

    var product_count_m_field = item.querySelector('.gform_repeater_count_m input');
    product_count_m_field.setAttribute("min", profile_form_m_min(item));
  });


  function profile_form_validate_count() {
    // validation message for count input field if number too low
    const profileFormCountM = document.querySelectorAll('.gform_repeater_count_m input');

    for (let i = 0; i < profileFormCountM.length; i++) {

      if (typeof(profileFormCountM[i]) != 'undefined' && profileFormCountM[i] != null) {
        profileFormCountM[i].addEventListener("input", (event) => {

          const input = event.target;
          const validity = input.validity.rangeUnderflow;
          const value_min = input.getAttribute("min");

          if (validity == true) {
            input.setCustomValidity(theme_strings.profile_form_count_error + value_min);
            // input.value = value_min;
          } else {
            input.setCustomValidity("");
          }

          input.reportValidity();
        });
      }

      if (typeof(profileFormCountM[i]) != 'undefined' && profileFormCountM[i] != null) {
        profileFormCountM[i].addEventListener("change", (event) => {

          const input = event.target;
          const validity = input.validity.rangeUnderflow;
          const value_min = input.getAttribute("min");

          if (validity == true) {
            input.value = value_min;
          }

          // input.reportValidity();
        });
      }
    }
  }

  // profile_form_default_values();
  profile_form_validate_count();

  // add default values to profile form repeater
  const repeater_items = document.querySelector('.gfield_repeater_items');

  if (typeof(repeater_items) != 'undefined' && repeater_items != null) {
    repeater_items.addEventListener('click', function(event) {

      if (event.target.matches('.add_repeater_item')) {

        const target = event.target;
        const next_item = target.closest('.gfield_repeater_item').nextSibling;
        const quality = next_item.querySelectorAll('.gfrom_repeater_quality .gchoice:first-child input');

        quality.forEach(async (item) => {
          item.checked = true;
        });

        profile_form_validate_count();
      }
    });
  }




  const profileForm = document.querySelector('#gform_fields_19');

  function handleFormChanges(event) {

    var element = event ? event.target : profileForm;
    var id = element.id;

    // changes on product repeater
    if (element.closest('.gfield_repeater_items') !== null) {

      // repeater item
      var parent_repeater_item = element.closest('.gfield_repeater_item');

      var product_count_m_field = parent_repeater_item.querySelector('.gform_repeater_count_m input');
      var product_count_m_value = product_count_m_field.value;
      var product_count_kg_field = parent_repeater_item.querySelector('.gform_repeater_count_kg input');

      var product_count_pcs_field = parent_repeater_item.querySelector('.gform_repeater_count_pcs input');

      // product select
      var product_select = parent_repeater_item.querySelector('.gfield--type-select select');
      var product_title = product_select.options[product_select.selectedIndex].innerHTML;
      var product_kgm = product_select.options[product_select.selectedIndex].getAttribute('data-profile-weight');

      // var product_kg_element = parent_repeater_item.querySelector('.profile-weight-kg');
      // var product_kg_value = Math.round(product_count_m_value * product_kgm);

      // product quality
      var product_quality = parent_repeater_item.querySelector('.gfield--type-radio input:checked').value;

      var kg_min = 0;

      // get kg min by quality
      if ( product_quality == 'en-aw-6063') {
        kg_min = 250;
      } else {
        kg_min = 500;
      }

      // get min count based on quality and selected product
      var product_count_min = Math.ceil(kg_min / product_kgm);

      product_count_m_field.setAttribute("min", product_count_min);

      // product field change
      if (id.includes('input_19_1001-')) {

        product_count_m_field.value = product_count_min;

        if (product_count_min * product_kgm < kg_min) {
          product_count_min = Math.ceil(kg_min / product_kgm);
          product_count_m_field.value = product_count_min;
        }

        product_count_kg_field.value = Math.round(product_count_min * product_kgm);

        if (!product_kgm || product_title.includes('SET')) {
          // add class to parent repeater item
          parent_repeater_item.classList.add('hide-count-fields');

          // if product has count pcs field then reset other count fields
          product_count_m_field.value = '';
          product_count_kg_field.value = '';

          // if product title contains "set" add min attribute count pcs field
          if (product_title.includes('SET')) {
            product_count_pcs_field.setAttribute("min", 15);
            product_count_pcs_field.setAttribute("step", 15);
            product_count_pcs_field.value = 15;

          } else {

            product_count_pcs_field.setAttribute("min", 50);
            product_count_pcs_field.setAttribute("step", 50);
            product_count_pcs_field.value = 50;
          }

        } else {
          parent_repeater_item.classList.remove('hide-count-fields');

          // reset count pcs field if product has kgm
          product_count_pcs_field.value = '';
        }
      }

      // count m field change
      if (id.includes('input_19_1002-')) {

        if (product_count_m_value < product_count_min) {
          // product_count_m_field.value = product_count_min;
        } else {
          product_count_kg_field.value = Math.round(product_count_m_value * product_kgm);
        }

      }

      // count kg field change
      if (id.includes('choice_19_1004_')) {

      }

      // quality field change
      if (id.includes('choice_19_1004_')) {
        product_count_m_field.value = product_count_min;

        if (product_count_min * product_kgm < kg_min) {
          product_count_min = Math.ceil(kg_min / product_kgm);
          product_count_m_field.value = product_count_min;
        }

        product_count_kg_field.value = Math.round(product_count_min * product_kgm);
      }
    }
  }

  if (typeof(profileForm) != 'undefined' && profileForm != null) {
    // Call the function on page load
    // handleFormChanges();

    // Attach the function to input event
    profileForm.addEventListener("input", handleFormChanges);
  }
});

jQuery(document).on('gform_post_render', function(){
  // make profile form kg field not selectable
    /* apply only to a input with a class of gf_readonly */
    jQuery('.gform_repeater_count_kg input').attr('tabindex','-1');
});

/**
 * Gravity Wiz // Gravity Forms // Disable Submission when Pressing Enter
 * https://gravitywiz.com/disable-submission-when-pressing-enter-for-gravity-forms/
 *
 * Instructions:
 * 1. Install our free Custom Javascript for Gravity Forms plugin.
 * Download the plugin here: https://gravitywiz.com/gravity-forms-custom-javascript/
 * 2. Copy and paste the snippet into the editor of the Custom Javascript for Gravity Forms plugin.
 */
jQuery(document).on( 'keypress', '.gform_wrapper', function (e) {
  var code = e.keyCode || e.which;
  if ( code == 13 && ! jQuery( e.target ).is( 'textarea,input[type="submit"],input[type="button"]' ) ) {
      e.preventDefault();
      return false;
  }
});


(function($) {
  $(document).on('gform_post_render', function(){
    $('.ginput_container > textarea, .ginput_container > input').each(function() {

      var $placeholder = $("label[for='"+this.id+"']");
      $placeholder.addClass('gfield_label_placeholder');

      if ($(this).val()) {
        $placeholder.addClass('gfield_label--focus');
        $(this).addClass('focused');
      }
    });

    $('.ginput_container > textarea, .ginput_container > input').focus( function() {

      var $label = $("label[for='"+this.id+"']");

      $label.addClass('gfield_label--focus');
      $(this).addClass('focused');
    });

    $('.ginput_container > textarea, .ginput_container > input').blur( function() {

      var $label = $("label[for='"+this.id+"']");
      if(!this.value) {
          $label.removeClass('gfield_label--focus');
          $(this).removeClass('focused');
      }
    });
  });
})(jQuery);
